import React, { useEffect, useState, useCallback } from "react";
import { Form, Row, Col, Button, Spin, Input, Tooltip } from "antd";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../../common";
import { useNavigate } from "react-router-dom";
import ytPlayBtn from "../../assets/images/YouTube_play_button.svg";
import "./Help.scss";
import ModalPlayer from "../ModalPlayer/ModalPlayer";
import { SearchOutlined, CloseOutlined } from "@ant-design/icons";
import backBtn from "../../assets/images/back-arrow.svg";
import { inputFieldCharLimit } from "../../config";
import { debounce } from 'lodash';
import SynthesiaImage from "../../assets/images/synthesia.jpg";
import PlayBtn from "../../assets/images/Play.svg";


function Help({ setActiveKey }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [videoUrl, setVideoUrl] = useState("");
  const [mediatype, setmediatype] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [helpTabName, setHelpTabName] = useState([]);
  const [searchTerm, setSearchTerm] = useState('')
  const [FilteredHelpTabName, setFilteredHelpTabName] = useState([])

  // Ultra-strict sanitization
  const sanitizeSearchInput = (input) => {
    if (input === undefined || input === null) return '';
    if (typeof input !== 'string') return '';

    // Only allow: letters, numbers, spaces, hyphens, underscores
    const sanitized = input.replace(/[^a-zA-Z0-9\s\-_]/g, '');

    console.log('🔍 Search Sanitization - Input:', `"${input}"`, 'Output:', `"${sanitized}"`);
    return sanitized;
  };

  // Safe URL parameter encoding
  const getSafeSearchParam = (input) => {
    if (!input || input.trim() === '') return '';

    const sanitized = sanitizeSearchInput(input.trim());
    if (!sanitized) return '';

    return encodeURIComponent(sanitized);
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  useEffect(() => {
    const uniqueTabs = [...new Set(data.map(item => item.assetTypeEnum))];
    setHelpTabName(uniqueTabs);
    setFilteredHelpTabName(uniqueTabs);
  }, [data]);

  const PlayVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  // Search change handler
  const handleSearchChange = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    setSearchTerm(sanitizedValue);

    if (sanitizedValue.trim().length > 0) {
      debouncedSearch(sanitizedValue);
    } else {
      // If search is cleared, get all data
      getHelpData('');
    }
  };

  // Handle enter key press
  const handlePressEnter = (e) => {
    const rawValue = e.target.value || '';
    const sanitizedValue = sanitizeSearchInput(rawValue);

    if (sanitizedValue.trim().length > 0) {
      getHelpData(sanitizedValue);
    }
  };

  const extractSynthesiaId = (url) => {
    const match = url.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
    return match ? match[0] : null;
  }

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm('');
    getHelpData('');
  };

  const getHelpData = async (searchValue = null) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      };

      let url;
      const currentSearchTerm = searchValue ?? searchTerm;

      if (currentSearchTerm && currentSearchTerm.trim() !== '') {
        const safeSearchParam = getSafeSearchParam(currentSearchTerm);
        if (!safeSearchParam) {
          // If search term becomes empty after sanitization, get all data
          url = userServiceApi.help();
        } else {
          url = userServiceApi.getFilteredHelpInfo('PARTNER_ADMIN', safeSearchParam);
        }
      } else {
        url = userServiceApi.help();
      }

      console.log('🌐 API URL:', url);

      const response = await getRequest(url, { headers });
      if (response) {
        setData(response.data || []);

        // Update filtered tab names
        const HelpTabNames = {};
        response.data.forEach((ele) => {
          if (!HelpTabNames[ele.assetTypeEnum]) {
            HelpTabNames[ele.assetTypeEnum] = true;
          }
        });
        setFilteredHelpTabName(Object.keys(HelpTabNames));
      }
    } catch (error) {
      console.error("Error fetching help data:", error);
      toast.error(error?.error || "Failed to load help data");
      setData([]);
      setFilteredHelpTabName([]);
    } finally {
      setLoading(false);
    }
  };



  // Debounced search
  const debouncedSearch = useCallback(
    debounce((value) => {
      getHelpData(value);
    }, 600),
    []
  );

  const tabName = (tab) => {
    const tabMap = {
      "FULL_MEMBERS": "Full Members",
      "CAROUSEL": "Carousel",
      "HUB_MEMBERS": "Hub Members",
      "SPONSOR_LOGOS": "Sponsor Logos",
      "ENGAGEMENT_TAB": "Dashboard",
      "RESTORE_MEMBERS": "Restore Members"
    };
    return tabMap[tab] || tab;
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Initial data load
  useEffect(() => {
    getHelpData();
  }, []);

  return (
    <>
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="searchbar-containers" style={{ marginTop: '10px' }} >
          <div className="d-flex align-items-center ">
            <img
              src={backBtn}
              onClick={() => setActiveKey('1')}
              alt="Back"
              style={{ cursor: 'pointer' }}
            />
            <span style={{ fontSize: '20px', fontWeight: 600 }} className="px-3" >Partner Help</span>
          </div>
          <Tooltip placement="top" title='Allowed: letters, numbers, spaces, hyphens (-), and underscores (_).'>
            <Input
              className="searchbar"
              placeholder="Search Help Content"
              value={searchTerm}
              suffix={
                searchTerm ? (
                  <CloseOutlined
                    style={{ color: "#CC0E2D", verticalAlign: "middle", cursor: 'pointer' }}
                    onClick={handleClearSearch}
                  />
                ) : (
                  <SearchOutlined
                    style={{ color: "#CC0E2D", verticalAlign: "middle" }}
                  />
                )
              }
              onChange={handleSearchChange}
              onPressEnter={handlePressEnter}
              style={{ width: '328px' }}
              maxLength={inputFieldCharLimit}
            />
          </Tooltip>
        </div>
        <hr style={{ marginTop: '15px' }} />

        {loading ? (
          <div className="no-data-warning" style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '50px' }} >
            <Spin tip="Loading" size="large" />
          </div>
        ) : (
          <>
            {FilteredHelpTabName && FilteredHelpTabName?.length > 0 ? (
              FilteredHelpTabName.map((tabNames) => (
                <div className="org-card-container" key={tabNames}>
                  <div className="title-help">{tabName(tabNames)}</div>
                  <Row gutter={[8, 8]}>
                    {data.filter(datas => datas?.assetTypeEnum === tabNames).map((datas) => (
                      <Col xs={24} sm={12} md={8} lg={8} key={datas.id}>
                        <div
                          className="card-item home-page-card-item card-hover"
                          bordered={false}
                        >
                          <div className="infoClass">
                            <div className="card-title">
                              {datas.title}
                            </div>
                            <div className="card-desc">
                              {datas.description}
                            </div>
                            {datas?.webLink ? (
                              <Button
                                type="primary"
                                className="redBtn btn-km"
                                onClick={() =>
                                  window.open(datas?.webLink, "_blank")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                Know More
                              </Button>
                            ) : null}
                          </div>
                          <div className="image-container cardContent">
                            {datas.mediaLink?.mediaType === "SOCIAL_MEDIA" && datas.mediaLink?.url ? (
                              <>
                                {(() => {
                                  const standardURL = convertToStandardURL(datas.mediaLink.url);
                                  const videoID = standardURL.split("v=")[1]?.split("&")[0];
                                  return (
                                    <div
                                      className="media youtube"
                                      style={{ objectFit: "contain", cursor: "pointer" }}
                                      onClick={() =>
                                        PlayVideoHandler(
                                          datas.mediaLink?.url,
                                          datas.mediaLink?.mediaType
                                        )
                                      }
                                    >
                                      <img
                                        src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                        alt=""
                                        className="video-preview-image"
                                        style={{
                                          height: "100%",
                                          borderRadius: "8px",
                                        }}
                                      />
                                      <img
                                        className="ytBtnOverlay"
                                        src={ytPlayBtn}
                                        alt="Play video"
                                      />
                                    </div>
                                  );
                                })()}
                              </>
                            ) : datas.mediaLink?.mediaType === "VIMEO_MEDIA" && datas.mediaLink?.url ? (
                              <div
                                className="media vimeo youtube"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  PlayVideoHandler(
                                    datas.mediaLink?.url,
                                    datas.mediaLink?.mediaType
                                  );
                                }}
                              >
                                <img
                                  src={`https://vumbnail.com/${datas.mediaLink?.url?.split("/")[4]}.jpg`}
                                  className="video-preview-image"
                                  style={{
                                    height: "100%",
                                    borderRadius: "8px",
                                  }}
                                  alt="Vimeo thumbnail"
                                />
                                <img
                                  className="ytBtnOverlay"
                                  src={ytPlayBtn}
                                  alt="Play video"
                                />
                              </div>
                            ) : datas.mediaLink?.mediaType ===
                              "SYNTHESIA_MEDIA" && datas.mediaLink?.url ? (
                              (() => {
                                const videoId = extractSynthesiaId(datas.mediaLink.url);
                                if (!videoId) return null;

                                return (
                                  <div
                                    className="media vimeo youtube"

                                    onClick={() =>
                                      PlayVideoHandler(
                                        `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                        datas.mediaLink.mediaType
                                      )
                                    }
                                  >
                                    <img
                                      src={datas?.mediaLink?.thumbnailUrl || SynthesiaImage}
                                      alt="Synthesia Video"
                                      className="video-preview-image"
                                      style={{
                                        height: "100%",
                                        borderRadius: "8px",
                                      }}
                                    />

                                    <img
                                      className="ytBtnOverlay"
                                      src={PlayBtn}
                                      alt="Play icon"
                                    />
                                  </div>
                                );

                              })()
                            ) : (
                              <div className="media">
                                <div className="slider-Img">
                                  <img
                                    src={datas.mediaLink?.url}
                                    alt=""
                                    className="home-preview-img"
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <div className='connectsu-line-help'></div>
                </div>
              ))
            ) : (
              <div className="org-card-container">
                <div className="no-data-message">
                  <h3 style={{ textAlign: "center", margin: "50px 0" }}>
                    {searchTerm ? `No results found for "${searchTerm}"` : "No data available"}
                  </h3>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {isModalOpen && (
        <ModalPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediatype}
        />
      )}
    </>
  );
}

export default Help;